export enum IncentiveKpiTargetSubtypeEnum {
  Compliance = 'Compliance',
  Individual = 'Individual',
  ProfitBased = 'Profit-based',
  RelativePerformance = 'Relative Performance',
  SalesCompensation = 'Sales Compensation',
  VolumeBased = 'Volume-based',
  Other = 'Other',
  NotAvailable = 'N/A'
}
